module.exports = __webpack_public_path__ + "img/profile.0bfd0c7e.svg";